<div class="page-container">
<div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3">
      <a href="/statistics" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">Statistiche Giorni Resi</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>      <div class="ms-auto">
        <!-- DESIGN OPTION 1: Modern Rounded Toggle -->
        <div class="statistics-toggle-group">
          <button 
            type="button"
            class="statistics-toggle-btn"
            [class.active]="selectedToggle === 'affido'"
            (click)="onToggle('affido')">
            <i class="fas fa-calendar-alt"></i>
            Per Data Affido
          </button>

          <button 
            type="button"
            class="statistics-toggle-btn"
            [class.active]="selectedToggle === 'creazione'"
            (click)="onToggle('creazione')">
            <i class="fas fa-plus-circle"></i>
            Per Data Creazione
          </button>
        </div>
      </div>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="onSubmit()">

      <div class="d-flex flex-wrap gap-3 mb-3">
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
              name="clients"
              [placeholder]="'Seleziona clienti'"
              [settings]="dropdownSettingsClient"
              [data]="filteredClients"
              [(ngModel)]="selectedClients"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onClientsChange()"
              (onDeSelect)="onClientsChange()"
              (onSelectAll)="selectAllClients()"
              (onDeSelectAll)="deselectAllClients()"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
          <label class="form-label">Marchi</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
              name="brands"
              [placeholder]="'Seleziona marchi'"
              [settings]="dropdownSettingsBrand"
              [data]="filteredBrands"
              [(ngModel)]="selectedBrands"
              [ngModelOptions]="{standalone: true}"
              >
            </ng-multiselect-dropdown>
          </div>
        </div>
        
        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Tipologia</label>
          <select class="form-select" [(ngModel)]="type" name="type">
            <option value="">Tutte</option>
            <option value="CAGE">Gabbie serigrafate</option>
            <option value="CNTR">Contenitori generici</option>
          </select>
        </div> 


        <!-- <div class="filter-item" style="min-width: 130px;">
          <label class="form-label">Data Inizio</label>
          <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">
        </div> -->

        <!-- <div class="filter-item" style="min-width: 130px;">
          <label class="form-label">Data Fine</label>
          <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
        </div> -->

        <div class="mb-2 d-flex">
          <div class="filter-item" style="min-width: 180px;">
            <label style="padding-left:30px;" class="form-label d-block">Data Inizio</label>
            <div class="d-flex align-items-center">
              <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>
              <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">

            </div>
          </div>

          <div class="filter-item" style="min-width: 180px;">
            <label class="form-label">Data Fine</label>
            <div class="d-flex align-items-center">
              <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
              <button class="date-nav-btn" type="button" (click)="incrementStartDate(); incrementEndDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-filter"></i>
          Applica Filtri
        </button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center">
    {{ error }}
  </div>  <div class="row px-3 mb-3">
    <div class="col-12 d-flex align-items-center justify-content-end gap-2 flex-wrap flex-md-nowrap">      
      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-hash"></i></span>
        <input type="text" class="form-control" [value]="totalItems" readonly style="max-width: 80px;">
      </div>

      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-view-list"></i></span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let size of [5, 10, 25, 50, 100]" [value]="size">{{size}}</option>
        </select>
      </div>
      
      <button class="btn btn-green w-auto"
              type="button"
              (click)="exportStatisticsToExcel()"
              title="Esporta Excel">
        <i class="fas fa-file-excel"></i>
      </button>
      
    </div>
  </div>
  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row mx-3">
    <div class="card table-container">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-bordered text-center">
            <thead class="table-light align-middle text-nowrap">
  <tr>
    <th>#</th>
    <th (click)="setSort('dataAffido')" style="cursor:pointer">
      {{ selectedToggle === 'affido' ? 'Data Affido' : 'Data Creazione' }}
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'dataAffido' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'dataAffido' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'dataAffido'
      }"></i>
    </th>
    <th>
      Stato 1 (Affidati)
    </th>

    <th colspan="2" class="text-center">Stato 2 (Ritirati dall’autista)</th>
    <th colspan="2" class="text-center">Stato 3 (Entrati in magazzino)</th>
    <th colspan="2" class="text-center">Stato 4 (Usciti dal magazzino)</th>
    <th colspan="4" class="text-center">Stato 5 (Consegnati)</th>
  </tr>
  <tr class="text-center small" *ngIf="selectedToggle === 'affido'" >
    <th style="background-color: white;" colspan="3"></th>
    <th style="background-color: #0d6efd0f;">Totale</th>
    <th style="background-color: #0d6efd0f;">% (su totale affidati)</th>
    <th style="background-color: #0d6efd0f;">Totale</th>
    <th style="background-color: #0d6efd0f;">% (su totale affidati)</th>
    <th style="background-color: #0d6efd0f;">Totale</th>
    <th style="background-color: #0d6efd0f;">% (su totale affidati)</th>
    <th style="background-color: #0d6efd0f;">Totale</th>
    <th style="background-color: #0d6efd0f;">% (su totale affidati)</th>
    <th style="background-color: #0d6efd0f;">In orario</th>
    <th style="background-color: #0d6efd0f;">% in orario (su totale affidati)</th>
  </tr>
</thead>

<tbody>
  <tr *ngFor="let stat of getPaginatedStats(); let i = index" class="align-middle text-nowrap text-center">
    <td>{{ pageIndex * pageSize + i + 1 }}</td>
    <td>{{ stat.dataAffido | date: 'dd/MM/yyyy' }}</td>
    <td>{{ stat.statoUno }}</td>

    <td [attr.colspan]="selectedToggle === 'creazione' ? 2 : 1">{{ stat.statoDue }}</td>
    <td *ngIf="selectedToggle === 'affido'">
      <ng-container *ngIf="selectedToggle === 'affido' && stat.statoUno; else dash2">
        <span class="badge"
          [ngClass]="getBadgeClass(stat.statoDue, stat.statoUno)">
          {{ (stat.statoDue / stat.statoUno * 100) | number:'1.0-2' }}%
        </span>
      </ng-container>
      <ng-template #dash2>-</ng-template>
    </td>

    <td [attr.colspan]="selectedToggle === 'creazione' ? 2 : 1">{{ stat.statoTre }}</td>
    <td *ngIf="selectedToggle === 'affido'">
      <ng-container *ngIf="selectedToggle === 'affido' && stat.statoUno; else dash3">
        <span class="badge"
          [ngClass]="getBadgeClass(stat.statoTre, stat.statoUno)">
          {{ (stat.statoTre / stat.statoUno * 100) | number:'1.0-2' }}%
        </span>
      </ng-container>
      <ng-template #dash3>-</ng-template>
    </td>

    <td [attr.colspan]="selectedToggle === 'creazione' ? 2 : 1">{{ stat.statoQuattro }}</td>
    <td *ngIf="selectedToggle === 'affido'">
      <ng-container *ngIf="selectedToggle === 'affido' && stat.statoUno; else dash4">
        <span class="badge"
          [ngClass]="getBadgeClass(stat.statoQuattro, stat.statoUno)">
          {{ (stat.statoQuattro / stat.statoUno * 100) | number:'1.0-2' }}%
        </span>
      </ng-container>
      <ng-template #dash4>-</ng-template>
    </td>

    <td [attr.colspan]="selectedToggle === 'creazione' ? 2 : 1">{{ stat.statoCinque }}</td>
    <td *ngIf="selectedToggle === 'affido'">
      <ng-container *ngIf="selectedToggle === 'affido' && stat.statoUno; else dash5">
        <span class="badge"
          [ngClass]="getBadgeClass(stat.statoCinque, stat.statoUno)">
          {{ (stat.statoCinque / stat.statoUno * 100) | number:'1.0-2' }}%
        </span>
      </ng-container>
      <ng-template #dash5>-</ng-template>
    </td>
    <td *ngIf="selectedToggle === 'affido'">{{ stat.consegnatiInOrario }}</td>
    <td *ngIf="selectedToggle === 'affido'">
      <ng-container *ngIf="selectedToggle === 'affido' && stat.statoUno; else dash6">
        <span class="badge"
          [ngClass]="getBadgeClass(stat.consegnatiInOrario, stat.statoUno)">
          {{ (stat.consegnatiInOrario / stat.statoUno * 100) | number:'1.0-2' }}%
        </span>
      </ng-container>
      <ng-template #dash6>-</ng-template>
    </td>
  </tr>

  <tr *ngIf="getPaginatedStats().length === 0">
    <td colspan="11" class="text-center py-3">Nessuna statistica trovata</td>
  </tr>
</tbody>

          </table>
        </div>
        <!-- Paginazione Bootstrap -->
        <div class="d-flex flex-column flex-md-row justify-content-end align-items-center p-2 gap-2">
      <nav aria-label="Paginazione tabella" *ngIf="totalItems > 0">
        <ul class="pagination mb-0">
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="firstPage()">
              <i class="bi bi-chevron-double-left"></i>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <span class="page-link">
                Pagina {{getNumberOfPages() === 0 ? 1 : pageIndex + 1}} di
                {{getNumberOfPages() === 0 ? 1 : getNumberOfPages()}}
            </span>
          </li>
          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="lastPage()">
              <i class="bi bi-chevron-double-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
      </div>
    </div>
  </div>


  



</div>